import HTTP from "@/http";

export function getShangPinFenLei(params = {}) {
  return HTTP({
    url: "api/shangpin/fenlei",
    method: "GET",
    params,
  });
}
